elabs.ArticleVideoSection = class ArticleVideoSection {
  constructor(sectionElement) {
    this.view = sectionElement;
    this.sectionId = this.view.dataset.sectionId;

    this.initVideos();
  }

  initVideos() {
    const videoWrappers = this.view.querySelectorAll('.el-article-video-section__inner');

    videoWrappers.forEach((wrapper) => {
      const btn = wrapper.querySelector('.el-article-video-section__video-video-play-btn');
      if (!btn) {
        return;
      }

      btn.addEventListener('click', () => {
        const poster = wrapper.querySelector('.el-article-video-section__video-poster');
        const iframe = wrapper.querySelector('iframe');
        const video = wrapper.querySelector('video');

        if (poster) {
          poster.classList.add('is-hidden');
        }

        if (video) {
          video.play();
          return;
        }

        if (iframe) {
          const src = iframe.getAttribute('src');
          if (!src) {
            return;
          }

          if (src.indexOf('autoplay=1') === -1) {
            const sep = src.indexOf('?') !== -1 ? '&' : '?';
            iframe.setAttribute('src', `${src}${sep}autoplay=1`);
          }
        }
      });
    });
  }
};

elabs.onJavascriptReady(() => {
  document.querySelectorAll('.el-article-video-section').forEach((element) => {
    if (element) {
      void new elabs.ArticleVideoSection(element);
    }
  });
});
